import {AfterViewInit, Component, ElementRef, Input, ViewChild, ViewEncapsulation} from '@angular/core';
import {gantt} from 'dhtmlx-gantt';
import {gantt as gantt_2} from './codebase/sources/dhtmlxgantt';
import {ApiRestService} from "../_services/api-rest.service";
import {FiltriInterventi} from "../Models/FiltriInterventi";
import {DatePipe} from "@angular/common";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-gantt',
  styleUrls: ['./dhtmlxgantt.css'],
  providers: [],
  template: `
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body p-t-0 p-b-0">
            <div class="row">
              <div class="col-lg-2">
                <div class="form-group">
                  <label for="inizio" class="control-label col-form-label">Inizio</label>
                  <input id="inizio" required [(ngModel)]="filtri.inizio" (ngModelChange)="refresh()" class="form-control" type="date">
                </div>
              </div>
              <div class="col-lg-2">
                <div class="form-group">
                  <label for="fine" class="control-label col-form-label">Fine</label>
                  <input id="fine" required [(ngModel)]="filtri.fine" (ngModelChange)="refresh()" class="form-control" type="date">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div #gantt_here style='width:100%; height: 450px;'></div>
    <hr>
    <div #gantt02 style='width:100%; height: 450px;'></div>
  `,
})
export class GanttComponent implements AfterViewInit {
  @ViewChild('gantt_here') ganttContainer: ElementRef;
  @ViewChild('gantt02') gantt2: ElementRef;
  filtri = new FiltriInterventi();
  @Input() Project_ID: number = undefined;
  private type: any;
  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private apiRestService: ApiRestService,
    private datePipe: DatePipe,
  ){ }

  ngAfterViewInit() {
    this.filtri.progetto = this.Project_ID;
    var now = new Date();
    this.filtri.inizio = this.datePipe.transform(new Date(now.getFullYear(),0,1,0,0), 'yyyy-MM-dd');
    this.filtri.fine = this.datePipe.transform(new Date(now.getFullYear()+1,0,0,23,59), 'yyyy-MM-dd');
    gantt_2.config.date_format = "%Y-%m-%d %H:%i:%s";
    gantt_2.config.start_date = new Date(now.getFullYear(),0,1,0,0);
    gantt_2.config.end_date = new Date(now.getFullYear()+1,0,0,23,59);
    gantt_2.config.readonly = true;
    gantt_2.init(this.gantt2.nativeElement);
    gantt_2.templates.task_class = function (start, end, task) {
      if(!task.parent) {
        return "fase";
      }
    };
    gantt.config.date_format = "%Y-%m-%d %H:%i:%s";
    gantt.config.start_date = new Date(now.getFullYear(),0,1,0,0);
    gantt.config.end_date = new Date(now.getFullYear()+1,0,0,23,59);
    gantt.config.readonly = true;
    gantt.init(this.ganttContainer.nativeElement);
    gantt.templates.task_class = function (start, end, task) {
      if(!task.parent) {
        return "fase";
      }
    };

    this.route.params.subscribe(data => {
      this.type= data['progetto'];
      if(this.type)
        this.filtri.progetto = parseInt(this.type);
      this.refresh();
    } )
    this.refresh();

  }

  refresh(){
    this.refreshData();
    this.refreshData();
  }
  refreshData(){
    this.apiRestService.GetGanntdata(this.filtri).subscribe(data => {
      gantt.clearAll();
      gantt.parse(data.previsti);
      gantt.refreshData();
      var fine = new Date(this.filtri.fine)
      gantt.config.start_date = new Date(this.filtri.inizio);
      gantt.config.end_date = new Date(fine.getFullYear(),fine.getMonth(),fine.getDate(),23,59);
      gantt_2.clearAll();
      gantt_2.parse(data.effettivi);
      gantt_2.refreshData();
      var fine = new Date(this.filtri.fine)
      gantt_2.config.start_date = new Date(this.filtri.inizio);
      gantt_2.config.end_date = new Date(fine.getFullYear(),fine.getMonth(),fine.getDate(),23,59);
    })
  }
}
